import { useMemo } from 'react';
import { useListViewNavigation } from '../../shared/useListViewNavigation';
import { NOTIFICATION_VIEW_ROUTES, readListParams } from '../notificationListParams';

export function useNotificationViewNavigation() {
    const nav = useListViewNavigation(NOTIFICATION_VIEW_ROUTES);
    const listParams = useMemo(() => readListParams(nav.searchParams), [nav.searchParams]);
    return { ...nav, listParams };
}
